import { paddingSmall } from "src/styles/spacing";

export const SEARCH_COMMUNITY_BASE_SIZE = 160;
export const SEARCH_COMMUNITY_SPACING = paddingSmall;
